import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {reaction} from 'mobx'
import {withRouter, Prompt} from 'react-router-dom'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import {Divider} from 'antd'
import LeaveModal from './Modals/Leave'
import MessagesModal from './Modals/Messages'
import Header from './Header'
import Controls from './Controls'
import Tabs from './Tabs'
import Progress from './Progress'

import style from './style.sass'

@withBoundary
@withRouter
@inject('store') @observer
class Backtest extends Component {
  state = {
    leaveModal: false,
    leavePath: null,
    messagesModal: false
  }
  async componentDidMount() {
    const {backtestID} = this.props.match.params
    const {backtest} = this.props.store
    backtest.editingAlgo = false
    await backtest.single.load(backtestID)
    reaction(
      () => backtest.messages.count,
      (count, reaction) => {
        this.setState({messagesModal: true})
        reaction.dispose()
      }
    )
    this.checkTab()
  }
  componentWillUnmount() {
    this.props.store.backtest.setBlankData()
  }
  changeTab = (key) => {
    key = key.replace(/[^\w\s]/gi, '')
    this.props.history.push({
      search: `tab=${key}`
    })
  }
  checkTab = async () => {
    const {search} = this.props.history.location
    const tab = search?.match(/tab=([^&]*)/)?.[1] || 'total'
    const {backtest} = this.props.store
    const {data, algo} = backtest.single
    if (data && algo?.all_tickers_count <= 1 && tab !== 'total') {
      this.changeTab('total')
    } else if (algo?.all_tickers_count > 1 && tab !== 'total' && tab !== 'byticker') {
      const {backtestID} = this.props.match.params
      await backtest.tables.fetchPnlByTicker(backtestID)
      const {size, loading} = backtest.tables.pnlByTicker
      if (!(loading || size)) {
        await backtest.calculatePnlByTicker()
        this.setTickerTab(tab)
      } else {
        this.setTickerTab(tab)
      }
    }
  }
  setTickerTab = (tab) => {
    const {backtest} = this.props.store
    if (backtest.tables.pnlTable.filter(row => row.key === tab)) {
      backtest.getTickerData(tab)
      this.changeTab(tab)
    } else {
      this.changeTab('total')
    }
  }
  onLeave = (location) => {
    const algoID = this.props.store.backtest.single.algo.id
    const backtestID = this.props.store.backtest.single.data.id
    if (
      location.pathname !== `/builder/edit/${algoID}` &&
      location.pathname !== `/backtest/algo/${backtestID}`
    ) {
      this.setState({leaveModal: true, leavePath: location.pathname})
      return false
    }
  }
  closeLeaveModal = () => {
    this.setState({leaveModal: false})
  }
  closeMessagesModal = () => {
    this.setState({messagesModal: false})
  }
  render() {
    const {backtest} = this.props.store
    const {data, algo} = backtest.single
    const title = algo.name ? algo.name + ' Backtest' : 'Backtest'

    const {editingAlgo} = backtest
    let changed = false
    const curr = this.props.store.algo.single.data
    const snap = backtest.algoSnapshot
    if (curr && snap) {
      changed = curr.signal !== snap.signal || curr.tickers !== snap.tickers || curr.stock_filter?.id !== snap.stock_filter?.id
    }
    return(
      <div>
        <Prompt when={editingAlgo && changed} message={this.onLeave}/>
        <LeaveModal visible={this.state.leaveModal} close={this.closeLeaveModal} leavePath={this.state.leavePath}/>
        <MessagesModal visible={this.state.messagesModal} close={this.closeMessagesModal}/>
        <DocumentTitle title={title}/>
        <Header title={title}/>
        <Divider styleName='divider'/>
        <Controls/>
        {data && data.is_currently_running === false
          ? <Tabs changeTab={this.changeTab}/>
          : <Progress percent={backtest.completedPercentage}/>
        }
      </div>
    )
  }
}

export default Backtest
